<template>
<div>
  <el-popover
      placement="bottom"
      width="280"
      trigger="click" style="line-height: 60px">
    <div class="flex">
      <!-- <div @click="changeTheme('#1890ff','#001223','#001c36','#0D60E2')" class="h-20 w-20 ml-1" style="background-color: #1890ff"></div> -->
      <div @click="changeTheme('#1890ff','#001223','#001223','#0D60E2')" class="h-20 w-20 ml-1" style="background-color: #1890ff"></div>
      <div @click="changeTheme('#3eaf7c','#091A12','#0e281c')" class="h-20 w-20 ml-1" style="background-color: #3eaf7c"></div>
      <div @click="changeTheme('#13c2c2','#031c1c','#042c2c')" class="h-20 w-20 ml-1" style="background-color: #13c2c2"></div>
      <div @click="changeTheme('#722ed1','#10071f','#1a0a30')" class="h-20 w-20 ml-1" style="background-color: #722ed1"></div>
      <div @click="changeTheme('#dc03fe','#10071f','#1a0a30')" class="h-20 w-20 ml-1" style="background-color: #dc03fe"></div>
      <div @click="changeTheme('#fadb14','#251F03','#3A3204')" class="h-20 w-20 ml-1" style="background-color: #fadb14"></div>
      <div @click="changeTheme('#eb2f96','#220716','#360b23')" class="h-20 w-20 ml-1" style="background-color: #eb2f96"></div>
      <div @click="changeTheme('#fa541c','#250C04','#3A1407')" class="h-20 w-20 ml-1" style="background-color: #fa541c"></div>
      <div @click="changeTheme('#f5222d','#2A0608','#42090C')" class="h-20 w-20 ml-1" style="background-color: #f5222d"></div>
    </div>
    <el-button type="text" slot="reference" style="color:#fff">主题</el-button>
  </el-popover>
</div>
</template>

<script>
import theme from "theme-vue";
import {setValue} from '@/utils/localStorage'
export default {
  name: "ThemeSelect",
  methods:{
    changeTheme(mainTheme, sideTheme, logoTheme,headerTheme){
      const th = new theme();
      headerTheme ? headerTheme : headerTheme = sideTheme;
      // headerTheme = sideTheme;
      th.changeTheme(mainTheme)
      setValue("theme",JSON.stringify({mainTheme,sideTheme,logoTheme,headerTheme}));
      this.$store.dispatch("changeTheme", {mainTheme,sideTheme,logoTheme,headerTheme})
    }
  }
}
</script>

<style scoped>

</style>
